import PropTypes from 'prop-types';
import React from 'react';

import { FileUpload, Spinner } from '@opendate-app/setlist';

const ImagePageDetail = ({
  csrfToken,
  team,
  currentUser,
  confirm,
  pageDetail,
  imageCalendarEventAttachments,
  uploadPageDetailImage,
  uploadPageDetailImageUrl,
  rootUrl
}) => (
  <div>
    {pageDetail._isLoading ? (
      <div className="mb-4 d-flex justify-content-center align-items-center"
           style={{
             "height": "195px",
             "border": "2px dashed var(--sl-border-primary)",
             "borderRadius": "var(--sl-radius-lg)"
           }}>
        <Spinner />
      </div>
    ) : pageDetail.renderable ? (
      <center>
        <img src={rootUrl + "image_page_details/" + pageDetail.token + "/download"}
             className="img-fluid" />
      </center>
    ) : (
      <React.Fragment>
        <FileUpload accept="image/*"
                    onFilesSelected={(files) => {
                      uploadPageDetailImage(csrfToken, team, pageDetail, files[0]);
                    }} />
        {imageCalendarEventAttachments.length > 0 ? (
          <div className="row mt-4">
            <div className="col-12">
              <div style={{
                     "background": "var(--sl-bg-secondary)",
                     "borderRadius": "var(--sl-radius-md)"
                   }}>
                <div className="p-3">
                  <p className="mb-0">
                    <strong>
                      Choose from existing event assets
                    </strong>
                  </p>
                  {imageCalendarEventAttachments.map((calendarEventAttachment, index) =>
                    <a key={index}
                       onClick={
                         (e) => {
                           e.preventDefault();
                           uploadPageDetailImageUrl(csrfToken, team, pageDetail, calendarEventAttachment.resolved_file_url);
                         }
                       }
                       href="#">
                      <div title={calendarEventAttachment.human_file_name}
                           className="d-inline-block mr-3 mt-3"
                           style={{
                             "width": "55px",
                             "height": "55px",
                             "borderRadius": "2px",
                             "backgroundSize": "cover",
                             "backgroundImage": "url(" + calendarEventAttachment.compressed_file_url + ")"
                           }}>
                      </div>
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </React.Fragment>
    )}
  </div>
);

ImagePageDetail.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  confirm: PropTypes.object.isRequired,
  pageDetail: PropTypes.object.isRequired,
  imageCalendarEventAttachments: PropTypes.array,
  uploadPageDetailImage: PropTypes.func.isRequired,
  uploadPageDetailImageUrl: PropTypes.func.isRequired,
  rootUrl: PropTypes.string.isRequired
};

export default ImagePageDetail;
